import { Component, OnInit, Injector, Input, EventEmitter, Output, DoCheck, AfterViewInit } from '@angular/core';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import * as _ from 'lodash';
import { NgControl, AbstractControl, FormControl, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { inputValidationMessage } from 'src/shared/validator/helper';
import { Observable } from 'rxjs';

@Component({
  selector: 'dcu-text-auto-complete',
  templateUrl: './text-auto-complete.component.html',
  styleUrls: ['./text-auto-complete.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: TextAutoCompleteComponent,
    multi: true
  }]
})
export class TextAutoCompleteComponent implements OnInit, DoCheck, AfterViewInit, ControlValueAccessor {

  @Input() minlength: number;

  @Output() selectedValueChange = new EventEmitter();

  @Output() editValue = new EventEmitter();

  @Output()
  eventEmitter = new EventEmitter();

  @Input() searchConfig: any;

  @Input() lstOptions: Observable<any>[];

  @Input() required = false;

  @Input() disabled = false;

  @Input() autoFieldId : string;

  @Input() label: string;
  data;
  selectedOption: any;
  selected: string;
  validationMessage = '';
  states: Observable<any>[];
  inputControl: any = new FormControl(null);
  parentControl: AbstractControl;
  onChange;
  onTouch;
  valueChange = false;
  validatorsBackup: any = null;

  constructor(private injector: Injector) {
  }

  ngDoCheck(): void {
    if (this.lstOptions) {
        // deal with asynchronous Observable result
      this.states = this.lstOptions;
    }
    if (this.parentControl) {
      this.validationMessage = inputValidationMessage(this.parentControl);
    }
  }

  ngAfterViewInit(): void {
    this.parentControl = this.injector.get(NgControl).control;
  }

  ngOnInit() {
    this.setDisabledState(this.disabled);
  }

  writeValue(value): void {
    if (value) {
        value = _.trim(value);
    }
    this.inputControl.setValue(value);
  }

  registerOnChange(fn) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    if (isDisabled) {
        this.inputControl.disable();
    } else {
        this.inputControl.enable();
    }
  }

  onInputChange() {
    this.parentControl.markAsTouched();
    if (this.onChange) {
        this.onChange(this.inputControl.value);
    }
    this.valueChange = true;
    // backup validators
    if (_.isNull(this.validatorsBackup)) {
        this.validatorsBackup = this.parentControl.asyncValidator;
    }
    // pending validator
    this.parentControl.clearAsyncValidators();
    this.parentControl.updateValueAndValidity();
  }

  onFocusout() {
    // If data not change then stop
    if (!this.valueChange) { return; }

    this.valueChange = false;
    this.eventEmitter.emit({ blur: true });
    // Update async validators
    this.parentControl.setAsyncValidators(this.validatorsBackup);
    this.parentControl.updateValueAndValidity();
  }

  onSelect(event: TypeaheadMatch): void {
    this.selectedOption = event.item;
    this.selectedValueChange.emit(this.selectedOption);
  }

  changeCodeValue(name) {
    this.editValue.emit(name);
  }

  onBlur(event: any) {
    if (_.isNull(event.target.value) || !this.states || (this.states && !this.states.length)) {
      return;
    }

    if (this.states.find(value => value['nameBinding'].toLowerCase() === event.target.value.toLowerCase())) {
      this.selectedOption = this.states.find(value => value['nameBinding'].toLowerCase() === event.target.value.toLowerCase());
      this.selectedValueChange.emit(this.selectedOption);
    } else {
      this.selectedValueChange.emit(event.target.value);
    }
  }

}
